export default __webpack_public_path__ + "5567c4e8f82512ea2df42acd77ab04ec.png";